export default __webpack_public_path__ + "static/media/thrivecart.54e7d655.svg";